export async function decodeAudioWithFallback<T>(
  primaryUrl: string,
  fallbackUrl: string | undefined,
  decode: (url: string) => Promise<T>,
): Promise<T> {
  try {
    return await decode(primaryUrl)
  } catch (error) {
    if (!fallbackUrl || fallbackUrl === primaryUrl) throw error
    return decode(fallbackUrl)
  }
}
